import React,{useState} from 'react'

import ImageDrawModal from "../canvas/ImageDrawModal";
import ImageDrawCard from "../canvas/ImageDrawCard";
import thumb26 from '../images/thumb_26.jpg';
import thumb27 from '../images/thumb_27.jpg';
import thumb28 from '../images/thumb_28.jpg';
import thumb29 from '../images/thumb_29.jpg';

import img26 from '../images/26.png';
import img27 from '../images/27.png';
import img28 from '../images/28.png';
import img29 from '../images/29.png';

import "./modal.css";


export default function Retina(){
    const [show,setShow] = useState(false);
    const [title,setTitle] = useState("Eye Lids");
    const [showImage,setShowImage] = useState(img26);
 
    const handleShow = (subtitle,imagename)=>{
         setTitle(subtitle)
         setShowImage(imagename)
         setShow(true)
    }
    const cards = [
        { title: "Retina - AMD Dry", thumb: thumb26, image: img26 },
        { title: "Retina - AMD Wet", thumb: thumb27, image: img27 },
        { title: "Retina - Diabetic Retinopathy", thumb: thumb28, image: img28 },
        { title: "Retina Detachment", thumb: thumb29, image: img29 },
    ]
    return(
        <>
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body py-4">
                    {/* Heading */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="h5 fw-bold mb-0">Retina</h3>
                    </div>

                    {/* Gallery */}
                    <div className="row g-4 row-cols-2 row-cols-md-3 row-cols-lg-5">
                        {cards.map((c, i) => (
                            <ImageDrawCard
                                key={i}
                                title={c.title}
                                thumb={c.thumb}
                                image={c.image}
                                onClick={handleShow}
                            />
                        ))}

                    </div>
                </div>
            </div>
            {/* Reusable modal */}
            {showImage && (
                <ImageDrawModal
                    show={show}
                    title={title}
                    image={showImage}
                    onClose={() => setShow(false)}
                />
            )}
        </>
    )
}